<template>
  <div>
    <el-dialog title="选择报销项目" :visible.sync="dialogVisible" :close-on-click-modal="false" width="800px">
      <div style="height: 500px;overflow-y: scroll">
        <el-table
          :data="tableData"
          style="width: 100%;margin-bottom: 20px;"
          row-key="id"
          border
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column prop="account_code" label="科目代码" ></el-table-column>
          <el-table-column prop="account_name" label="科目名称"></el-table-column>
          <el-table-column label="金额">
            <template slot-scope="scope">
              <a v-if="scope.row.children.length == 0" href="javascript:void(0);" @click="selectItem(scope.row)">{{scope.row.allow_reimburse}}</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false;callback=undefined">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from "../common/Http";

export default {
  name: "SelectExpenseAccount",
  data(){
    return{
      dialogVisible:false,
      tree_str:"",
      id:"",
      tree_obj:{},
      name:"id",
      value:"",
      callback:null,
      tableData: [

      ]
    }
  },
  mounted() {

  },
  methods:{
    show(config,callback){
      console.info(config)
      const that = this;
      that.dialogVisible=true;
      that.callback=callback;
      let budgetUrl = window.Glob.budget;
      Http.get(budgetUrl + "/admin/budgetSendApi/sendEepenseApply",config,function (res) {
        if (res.code) {
          that.tableData = res.data
        }
      })
    },

    selectItem(data){
      const that = this;
      typeof that.callback==="function"&&that.callback(data)
      that.dialogVisible=false;
      that.callback=undefined;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectExpenseAccount.vue